import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaEdit } from "react-icons/fa";

import AddSection from '../../../components/content-management/sections/add/add-section.component.jsx';
import Button from '../../../components/reusable/button/button.component.jsx';
import ComponentModal from '../../../components/reusable/component-modal/component-modal.component.jsx';
import PageDisplay from '../../../components/content-management/pages/display/page-display.component.jsx';
import Sections from '../../../components/reusable/tables/sections-table/sections-table.component.jsx';
import Spinner from '../../../components/reusable/spinner/spinner.component.jsx';
import UpdatePage from '../../../components/content-management/pages/update-page/update-page.component.jsx';

import { ConfigurationContext } from '../../../contexts/configuration.context.jsx';

import Client from '../../../tools/client.js';

import {
  CMSOptionsContainer
} from './cms-page.styles.jsx';

import {
  BackLink,
  ButtonGroup,
  ContentContainer,
  MainContainer,
  MainTitle,
  Subtitle
} from '../../../styles/page.styles.jsx';

const client = new Client();

const CMSPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [showAddSection, setShowAddSection] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [page, setPage] = useState('');
  const [sections, setSections] = useState('');
  const { id } = useParams();

  const { configuration, refreshConfiguration } = useContext(ConfigurationContext);

  useEffect(() => {
    getPage();
    // eslint-disable-next-line
  }, []);

  const getPage = async () => {
    setLoading(true);
    const res = await client.getPageById(id);
    const sortedSections = [...res.Sections].sort((a, b) => a.position - b.position);
    setPage(res);
    setSections(sortedSections);
    setLoading(false);
  };

  const setAsLandingPage = async () => {
    await client.updateConfigurationByKey('app.landingPage.id', { value: page.id });
    await refreshConfiguration();
    await getPage();
  };

  const display = () => {
    if (showUpdate) {
      return (
        <UpdatePage page={page} pageTypes={page.PageTypes} getPage={getPage} setShowUpdate={setShowUpdate} />
      );
    }

    return (
      <ContentContainer>
        <ComponentModal isOpen={showAddSection} onClose={() => setShowAddSection(false)}>
          <AddSection page={page} getPage={getPage} />
        </ComponentModal>

        <CMSOptionsContainer>
          <FaEdit onClick={() => setShowUpdate(true)} />
        </CMSOptionsContainer>

        <MainTitle>Page: {page.title}</MainTitle>
        {configuration?.app?.landingPage.id == page.id && (
          <Subtitle>Current Landing Page</Subtitle>
        )}

        <PageDisplay page={page} />

        <ButtonGroup>
          {configuration?.app?.landingPage.id !== page.id && (
            <Button onClick={setAsLandingPage}>Set As Landing Page</Button>
          )}
          <Button onClick={() => setShowAddSection(true)}>Add Section</Button>
        </ButtonGroup>



        <Sections sections={sections} />
      </ContentContainer>
    );
  };

  return (
    <MainContainer>
      <BackLink onClick={() => navigate(`/content-management`)}>
        Back To Content Management
      </BackLink>
      {loading || !configuration ? (
        <Spinner />
      ) : !page ? (
        <MainTitle>No Page to Display</MainTitle>
      ) : (
        display()
      )}
    </MainContainer>
  );
};

export default CMSPage;